import React from "react";
import { Container, Col, Card } from "react-bootstrap";
import { object, bool } from "prop-types";
import { format } from "date-fns";
import scoreRangesMetBadge from "resources/images/score-ranges-met-badge.png";
import { convertDateTimezone } from "utils/helperFunctions";

const CandidateInfoSection = ({ candidateInfo, metAllScoreRanges }) => {
  const showTalentSignal = candidateInfo.get("rankingScore");
  const isAU = candidateInfo.get("locale") === "AU";

  return (
    <Container className="my-4">
      <Card className="d-flex flex-row justify-content-between p-3">
        <Col lg={6} className="pt-2">
          <h1
            className="font-weight-bold criteria-navy-color"
            style={{
              fontSize: "28px",
              margin: "5px 0px 5px 0px",
            }}
          >
            {`${candidateInfo.get("testTakerFirstName")} ${candidateInfo.get(
              "testTakerLastName"
            )}`}
          </h1>
          <p className="mb-0">
            {`${candidateInfo.get("testTakerEmail")} | Test Date: ${format(
              convertDateTimezone(candidateInfo.get("dateEventTaken"), isAU),
              "MMM dd, yyyy"
            )}`}
          </p>
          <p>{candidateInfo.get("position")}</p>
        </Col>
        <Col
          lg={6}
          className="d-flex flex-column justify-content-center align-items-end"
        >
          {showTalentSignal && (
            <div className="d-flex">
              <div
                className="text-white"
                style={{
                  backgroundColor: "#001f4e",
                  fontSize: "24px",
                  marginRight: "1px",
                  padding: "10px 10px",
                }}
              >
                {candidateInfo.get("rankingScore")}
              </div>
              <div
                className="text-white"
                style={{
                  backgroundColor: "#001f4e",
                  fontSize: "13px",
                  padding: "18px",
                  borderRadius: "0px 0px 20px 0px",
                }}
              >
                Talent Signal
              </div>
            </div>
          )}
          {metAllScoreRanges && (
            <div className="pt-2">
              <img
                src={scoreRangesMetBadge}
                alt="Score Ranges Met"
                title="Score Ranges Met"
                style={{ width: "160px", marginRight: "-2px" }}
              />
            </div>
          )}
        </Col>
      </Card>
    </Container>
  );
};

CandidateInfoSection.propTypes = {
  candidateInfo: object,
  metAllScoreRanges: bool,
};

export default CandidateInfoSection;
